module.exports = __webpack_public_path__ + "static/linkedin-da6b1b70c71e95799be795414becc2e8.png";